"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ResourceLogModel () {
        return ResourceLogModel;
    },
    get ResourceLogResourceChangeTypes () {
        return ResourceLogResourceChangeTypes;
    },
    get ResourceLogResourceTypes () {
        return ResourceLogResourceTypes;
    }
});
const _zod = require("zod");
const _resources = require("./resources");
const ResourceLogModel = _zod.z.discriminatedUnion("resourceType", [
    _resources.AutoflowResourceLog,
    _resources.ReviewCycleResourceLog
]);
const ResourceLogResourceTypes = _zod.z.union([
    _resources.AutoflowResourceLog.shape.resourceType,
    _resources.ReviewCycleResourceLog.shape.resourceType
]);
const ResourceLogResourceChangeTypes = _zod.z.union([
    _resources.AutoflowResourceLog.shape.changeType,
    _resources.ReviewCycleResourceLog.shape.changeType
]);
